import { login } from "@/apis"
import { ROUTER_LOGIN } from "@/entry/route"

export const goLogin = () => {
    window.open(ROUTER_LOGIN, '_self')
}

export const goOAuthLogin = () => {
  login().then(res => {
    window.open(res.data.url, '_self')
  }).catch(err => {
    console.error("OAuth login failed:", err)
  })
}
